// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__vF39f","consentsList":"PatientConsents_consentsList__1r3Xp","consentsListEmpty":"PatientConsents_consentsListEmpty__13MBw"};